const COUNTRY_CODES = [
  'US', 'CA', 'MX', 'BR', 'AR', 'CL', 'CO', 'PE',
  'GB', 'IE', 'FR', 'DE', 'ES', 'IT', 'PT', 'NL', 'BE', 'CH', 'AT', 'SE',
  'NO', 'DK', 'FI', 'PL', 'CZ', 'HU', 'RO', 'BG', 'GR', 'TR', 'UA', 'RS',
  'HR', 'SI', 'SK', 'EE', 'LV', 'LT',
  'RU', 'KZ', 'GE', 'AM', 'AZ',
  'AE', 'SA', 'QA', 'KW', 'BH', 'OM', 'IL', 'EG', 'MA', 'TN', 'DZ', 'ZA',
  'IN', 'PK', 'BD', 'LK', 'NP',
  'CN', 'JP', 'KR', 'TW', 'HK', 'SG', 'MY', 'TH', 'VN', 'PH', 'ID',
  'AU', 'NZ',
]

const LANGUAGE_CODES = [
  'en', 'ru', 'uk', 'es', 'pt', 'fr', 'de', 'it', 'nl', 'pl', 'cs',
  'tr', 'ar', 'he', 'hi', 'bn', 'ur', 'fa',
  'zh', 'zh-Hans', 'zh-Hant', 'ja', 'ko', 'th', 'vi', 'id', 'ms', 'tl',
]

const FALLBACK_TIMEZONES = [
  'UTC',
  'Europe/London',
  'Europe/Berlin',
  'Europe/Paris',
  'Europe/Moscow',
  'Europe/Istanbul',
  'Asia/Dubai',
  'Asia/Kolkata',
  'Asia/Bangkok',
  'Asia/Shanghai',
  'Asia/Tokyo',
  'Asia/Seoul',
  'Australia/Sydney',
  'America/New_York',
  'America/Chicago',
  'America/Denver',
  'America/Los_Angeles',
  'America/Sao_Paulo',
]

function buildCountryOptions() {
  try {
    const display = new Intl.DisplayNames(['en'], { type: 'region' })
    return COUNTRY_CODES.map((code) => ({
      value: code.toLowerCase(),
      label: `${code} - ${display.of(code) || code}`,
    }))
  } catch {
    return COUNTRY_CODES.map((code) => ({ value: code.toLowerCase(), label: code }))
  }
}

function buildLanguageOptions() {
  return LANGUAGE_CODES.map((code) => {
    try {
      const locale = new Intl.Locale(code)
      const baseName = locale.baseName || code
      return {
        value: baseName.toLowerCase(),
        label: baseName,
      }
    } catch {
      return {
        value: code.toLowerCase(),
        label: code,
      }
    }
  })
}

function buildTimezoneOptions() {
  try {
    if (typeof Intl.supportedValuesOf === 'function') {
      return Intl.supportedValuesOf('timeZone').map((timezone) => ({
        value: timezone,
        label: timezone,
      }))
    }
  } catch {
    // no-op
  }
  return FALLBACK_TIMEZONES.map((timezone) => ({ value: timezone, label: timezone }))
}

const COUNTRY_OPTIONS = buildCountryOptions()
const LANGUAGE_OPTIONS = buildLanguageOptions()
const TIMEZONE_OPTIONS = buildTimezoneOptions()

const USER_PARAMETER_OPTIONS = [
  {
    key: 'country',
    label: 'Country',
    allowMultiple: true,
    input: 'select',
    values: COUNTRY_OPTIONS,
  },
  {
    key: 'not_in_country',
    label: 'Not In Country',
    allowMultiple: true,
    input: 'select',
    values: COUNTRY_OPTIONS,
  },
  {
    key: 'language',
    label: 'Language',
    allowMultiple: true,
    input: 'select',
    values: LANGUAGE_OPTIONS,
  },
  {
    key: 'timezone',
    label: 'Timezone',
    allowMultiple: true,
    input: 'select',
    values: TIMEZONE_OPTIONS,
  },
  { key: 'campaign', label: 'Campaign', allowMultiple: true, input: 'text' },
  { key: 'lifetime', label: 'Lifetime', allowMultiple: false, input: 'number' },
  { key: 'rv_total', label: 'RV total', allowMultiple: false, input: 'number' },
  { key: 'rv_day', label: 'RV last day', allowMultiple: false, input: 'number' },
  { key: 'level', label: 'Level', allowMultiple: false, input: 'number' },
  {
    key: 'payable',
    label: 'Payer',
    allowMultiple: false,
    input: 'select',
    values: [
      { value: '1', label: 'Payable' },
      { value: '0', label: 'Unpayable' },
    ],
  },
  {
    key: 'payer_segmentation',
    label: 'Payer segmentation',
    allowMultiple: false,
    input: 'select',
    values: [
      { value: 'non_payer', label: 'non_payer' },
      { value: 'small_payer', label: 'small_payer' },
      { value: 'mid_payer', label: 'mid_payer' },
      { value: 'high_payer', label: 'high_payer' },
      { value: 'dormant_small', label: 'dormant_small' },
      { value: 'dormant_high', label: 'dormant_high' },
    ],
  },
  {
    key: 'traffic_type',
    label: 'Traffic Type',
    allowMultiple: false,
    input: 'select',
    values: [
      { value: 'organic', label: 'organic' },
      { value: 'paid', label: 'paid' },
    ],
  },
  { key: 'adtag', label: 'Ad tag', allowMultiple: true, input: 'text' },
  { key: 'user_purchases', label: 'SKU id', allowMultiple: true, input: 'text' },
  { key: 'install_date', label: 'Install date', allowMultiple: false, input: 'date_range' },
]

const OPTION_BY_KEY = Object.fromEntries(USER_PARAMETER_OPTIONS.map((item) => [item.key, item]))

function makeConditionId() {
  return `cond_${Date.now()}_${Math.random().toString(16).slice(2)}`
}

function normalizePattern(pattern) {
  if (!pattern || typeof pattern !== 'object') return null
  const rawType = pattern.pattern_type ?? pattern.patternType ?? pattern.type
  const rawValue =
    pattern.pattern_value !== undefined
      ? pattern.pattern_value
      : pattern.patternValue !== undefined
        ? pattern.patternValue
        : pattern.value
  if (!rawType) return null
  if (rawType === 'non_payable') {
    return { type: 'payable', value: 0 }
  }
  return { type: String(rawType), value: rawValue }
}

function formatDateFromSeconds(value) {
  const num = Number(value)
  if (!Number.isFinite(num)) return String(value ?? '')
  return new Date(num * 1000).toISOString().slice(0, 10)
}

export function createEmptyCondition(key = 'country') {
  return {
    id: makeConditionId(),
    key,
    value: '',
    from: '',
    to: '',
  }
}

export function getUserParameterOptions() {
  return USER_PARAMETER_OPTIONS
}

export function getUserParameterByKey(key) {
  return OPTION_BY_KEY[key] || null
}

function conditionToDisplayRow(condition) {
  const parameter = getUserParameterByKey(condition.key)
  if (!parameter) return null
  if (parameter.input === 'date_range') {
    const from = String(condition.from || '')
    const to = String(condition.to || '')
    return {
      label: parameter.label,
      value: from && to ? `${from} - ${to}` : from || to,
    }
  }
  if (parameter.input === 'select') {
    const selected = parameter.values?.find((item) => String(item.value) === String(condition.value))
    return { label: parameter.label, value: selected?.label || String(condition.value || '') }
  }
  return { label: parameter.label, value: String(condition.value || '') }
}

export function buildConditionsFromPatterns(patterns) {
  const normalized = Array.isArray(patterns) ? patterns.map(normalizePattern).filter(Boolean) : []

  const startInstall = []
  const endInstall = []
  const regular = []

  for (const pattern of normalized) {
    if (pattern.type === 'start_install') {
      startInstall.push(pattern.value)
      continue
    }
    if (pattern.type === 'end_install') {
      endInstall.push(pattern.value)
      continue
    }
    regular.push({
      id: makeConditionId(),
      key: pattern.type,
      value: pattern.value === undefined || pattern.value === null ? '' : String(pattern.value),
      from: '',
      to: '',
    })
  }

  const installCount = Math.max(startInstall.length, endInstall.length)
  for (let idx = 0; idx < installCount; idx += 1) {
    regular.push({
      id: makeConditionId(),
      key: 'install_date',
      value: '',
      from: startInstall[idx] !== undefined ? formatDateFromSeconds(startInstall[idx]) : '',
      to: endInstall[idx] !== undefined ? formatDateFromSeconds(endInstall[idx]) : '',
    })
  }

  return regular.filter((item) => getUserParameterByKey(item.key))
}

function toUnixSeconds(dateValue) {
  const date = new Date(`${dateValue}T00:00:00Z`)
  return Number.isNaN(date.getTime()) ? null : Math.floor(date.getTime() / 1000)
}

export function buildPatternsFromConditions(conditions) {
  const rows = Array.isArray(conditions) ? conditions : []
  const patterns = []

  for (const row of rows) {
    const option = getUserParameterByKey(row.key)
    if (!option) continue

    if (option.input === 'date_range') {
      const from = String(row.from || '').trim()
      const to = String(row.to || '').trim()
      if (!from || !to) continue
      const fromTs = toUnixSeconds(from)
      const toTs = toUnixSeconds(to)
      if (fromTs === null || toTs === null) continue
      patterns.push({ pattern_type: 'start_install', pattern_value: fromTs })
      patterns.push({ pattern_type: 'end_install', pattern_value: toTs })
      continue
    }

    const rawValue = String(row.value || '').trim()
    if (!rawValue) continue

    if (option.input === 'number') {
      const parsed = Number(rawValue)
      if (!Number.isFinite(parsed)) continue
      patterns.push({ pattern_type: row.key, pattern_value: parsed })
      continue
    }

    if (row.key === 'payable') {
      patterns.push({ pattern_type: 'payable', pattern_value: Number(rawValue) })
      continue
    }

    patterns.push({ pattern_type: row.key, pattern_value: rawValue })
  }

  return patterns
}

export function buildDisplayRowsFromPatterns(patterns) {
  const conditions = buildConditionsFromPatterns(patterns)
  return conditions.map(conditionToDisplayRow).filter(Boolean)
}

export function buildSegmentationNameFromConditions(conditions) {
  const rows = (Array.isArray(conditions) ? conditions : [])
    .map(conditionToDisplayRow)
    .filter((item) => item && item.value)
  if (rows.length === 0) return ''
  return rows
    .map((item) => `${item.label}: ${item.value}`)
    .join(', ')
    .slice(0, 256)
}

